import { agentType } from "../../containers/ccsmodule/queues/settings/componenets/agentType";
import { Queuetype } from "../../containers/ccsmodule/queues/settings/componenets/queueType";
import { supervisorType } from "../../containers/ccsmodule/queues/settings/componenets/supervisorType";
import { SupervisorQueueType } from "../action-types/supervisorQueues.action.types";

export const setQueues = (data: Queuetype[]) => {
  console.log("firstfirstfirstfirst", data);
  return {
    type: SupervisorQueueType.SET_QUEUES,
    payload: data,
  };
};
export const setAgents = (data: agentType[]) => {
  console.log("firstfirstfirstfirst", data);
  return {
    type: SupervisorQueueType.SET_AGENTS,
    payload: data,
  };
};

export const setSupervisors = (data: supervisorType[]) => {
  console.log("firstfirstfirstfirst", data);
  return {
    type: SupervisorQueueType.SET_SUPERVISORS,
    payload: data,
  };
};
